import router from '../router/index.js'
import store from '../store'
import { HTTP_ERROR_MESSAGES } from '@/utils/constants'
// error logger
export const errorLogger = function (error) {
  store.dispatch('error/setError', error)
}

export const handleErrorMessage = function (error) {
  if (error.response) {
    // The request was made, but the server responded with a status code outside the range of 2xx
    const statusCode = error.response.status
    switch (statusCode) {
      case 401:
        handle401Error(error)
        return HTTP_ERROR_MESSAGES[statusCode].message
      default:
        return HTTP_ERROR_MESSAGES[statusCode]
          ? HTTP_ERROR_MESSAGES[statusCode].message
          : 'Something went wrong. Please try again later.'
    }
  } else if (error.request) {
    // The request was made, but no response was received
    return 'No response from the server. Please check your internet connection and try again.'
  } else {
    // Something happened in setting up the request that triggered an error
    return 'An unexpected error occurred. Please try again later.'
  }
}

export const handle401Error = function (error) {
  if (error.response?.data) {
    if (
      error.response.data.code === 401 &&
      (router.currentRoute.name !== 'accountSetup' ||
        router.currentRoute.name !== 'submit-kyc')
    ) {
      error.response.data.error.publicMessage = 'Session Expired'
      //  set hasEncountered401Error
      store.dispatch('error/setHasEncountered401Error')
      // reset store state
      resetStoreStates()
      // route to login screen
      router.push({ name: 'login' })
    }
  }
}

const resetStoreStates = function () {
  store.dispatch('terminal/resetTerminalState')
  store.dispatch('bulkPayout/resetBulkPayoutState')
  store.dispatch('auth/resetAuthState')
  store.dispatch('report/resetReportState')
  store.dispatch('transactions/resetTransactionsState')
  store.dispatch('withdrawal/resetWithdrawalState')
  store.dispatch('externalApi/resetExternalApiState')
  store.dispatch('common/resetCommonState')
  store.dispatch('notification/resetNotificationState')
  setTimeout(() => {
    store.dispatch('error/resetErrorState')
  }, 500)
}
